
export default {
  name: 'DiscountText',
  props: {
    discountCurrency: {
      type: String,
      required: false,
    },
    discountPromoCode: {
      type: String,
      required: true,
    },
    discountPercent: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
}
